export default "__VITE_PUBLIC_ASSET__0fa969ed__"